import { render, staticRenderFns } from "./ArquivoAnalise.vue?vue&type=template&id=4606f59c&scoped=true"
import script from "./ArquivoAnalise.vue?vue&type=script&lang=js"
export * from "./ArquivoAnalise.vue?vue&type=script&lang=js"
import style0 from "./ArquivoAnalise.vue?vue&type=style&index=0&id=4606f59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606f59c",
  null
  
)

export default component.exports